<template>
  <div class="nav_bar">
    <el-row class="nav">
      <el-col :span="4">
        <div class="logo_box">
          <Logo></Logo>
				</div>
      </el-col>
      <el-col :span="4">
        <div class="name" @click="backConsole">控制台</div>
      </el-col>
      <el-col :span="16" align="right">
        <!-- <div class="right_option">
          <div>
            <i class="el-icon-search"></i>
          </div>
          <div>
            <router-link :to="{name:'messageCenter'}">
              <i class="el-icon-message"></i>
            </router-link> 
          </div>
          <div><router-link :to="{name:'productManagement'}">产品管理</router-link></div>
          <div><router-link :to="{name:'contractManagement'}">合同管理</router-link></div>
          <div><router-link :to="{name:'resourceManagement'}">资源管理</router-link></div>
          <div><router-link :to="{name:'document'}">文档</router-link></div>
          <div><router-link :to="{name:'supportServices'}">支持与服务</router-link></div>
          <div><router-link :to="{name:'accountCenter'}">账户中心</router-link></div>
        </div> -->
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1">
            <!-- 搜索 -->
            <i class="el-icon-search" v-if="!searchBoxVisible" @click="dispaySearchBox"></i>
            <el-input v-if="searchBoxVisible" v-model="searchValue" placeholder="输入您想要搜索的关键词" size="small" style="width:250px">
              <template #suffix>
                  <i class="el-input__icon el-icon-search" @click="search"></i>
                  <span>|</span>
                  <i class="el-input__icon el-icon-close" @click="hideSearchBox"></i>
              </template>
            </el-input>
          </el-menu-item>
          <!-- 消息中心 -->
          <el-menu-item index="2" class="message_center">
            <router-link :to="{path:'/messageCenter'}"
              @mouseenter.native="showMessageBox"
		    			@mouseleave.native="hideMessageBox">
                <i class="el-icon-message"></i>
                <transition name="fade" appear>
                  <div class="message_box" v-show="messageBoxVisible">
                    <div class="box_title">
                      <span>消息中心</span>
                      <i @click="enterMessageCenter">更多</i>
                    </div>
                    <div class="message_item" v-for="(item,index) in messageTableData" :key="index" @click="enterMessageCenter">
                      <div class="message_title">{{item.summary}}</div>
                      <div class="message_time">{{item.publishTime}}</div>
                    </div>
                  </div>
		    				</transition>
            </router-link>
          </el-menu-item>
          <el-menu-item index="3"><router-link :to="{path:'/productManagement'}">产品管理</router-link></el-menu-item>
          <el-menu-item index="4"><router-link :to="{path:'/contractManagement'}">合同管理</router-link></el-menu-item>
          <el-menu-item index="5"><router-link :to="{path:'/resourceManagement'}">资源管理</router-link></el-menu-item>
          <el-menu-item index="6"><router-link :to="{path:'/document'}">文档</router-link></el-menu-item>
          <!-- 支持与服务 -->
          <el-submenu index="7">
            <template slot="title">
              <router-link :to="{path:'/supportServices'}">支持与服务</router-link>
            </template>
            <el-menu-item class="hover_item" index="7-0">创建工单</el-menu-item>
            <el-menu-item class="hover_item" index="7-1">我的工单</el-menu-item>
            <el-menu-item class="hover_item" index="7-2">在线客服</el-menu-item>
            <el-menu-item class="hover_item" index="7-3">常见问题及解决方案</el-menu-item>
            <el-menu-item class="hover_item" index="7-4">反馈及意见</el-menu-item>
          </el-submenu>
          <!-- 账户中心 -->
          <el-submenu index="8">
            <template slot="title">
              <img class="head_portrait" src="../../assets/console/user_avatar.png" alt="">
              <router-link :to="{path:'/accountCenter'}">{{username}}</router-link>
            </template>
            <el-menu-item class="hover_item" index="8-0">账户信息</el-menu-item>
            <el-menu-item class="hover_item" index="8-1">账户认证</el-menu-item>
            <el-menu-item class="exit_btn hover_item" index="8-2">退出</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryMessageByConditions } from '@/api/console/messageCenter.js'
import token from '@/utils/token.js'
import Logo from '@/components/common/logo.vue'
    export default {
      components: {
        Logo,
      },
      data() {
        return {
          username: '',//用户名
          activeIndex: '',
          searchValue: '',
          searchBoxVisible: false,
          messageBoxVisible: false,//消息盒子是否显示
          messageTableData: [],//消息中心列表
        }
      },
      created() {
        this.getData();
      },
      methods: {
        getData() {
          this.username = token.getUser().username;
          this.queryMessageList();//查询消息中心列表
        },
        backHome() {
          this.$router.push({
              path: '/'
          })
        },
        backConsole() {
          this.$router.push({
              path: '/console'
          })
        },
        //搜索框
        dispaySearchBox() {
          this.searchBoxVisible = true;
        },
        search () {
          
        },
        //消息中心
        async queryMessageList() {
          let param = {
            isReading: '0',
            categoryId: 0,
            nowPage: 1,
            pageSize: 5,
            title: '',
            userId: token.getUser().id
          } 
          let messageTableObj = await queryMessageByConditions(param);
          this.messageTableData = messageTableObj.data.list;
        },
        showMessageBox() {
          this.messageBoxVisible = true;
        },
        hideMessageBox() {
          this.messageBoxVisible = false;
        },
        hideSearchBox() {
          this.searchBoxVisible = false;
        },
        enterMessageCenter() {
          this.$router.push({path: '/messageCenter'})
        },
         handleSelect(key) {
          if(key.substring (0,1) == 7) {
            let index = key.charAt(key.length - 1);
            this.$router.push({path: '/supportServices',query:{ index:index}});
          }
          if(key.substring (0,1) == 8) {
            if(key == '8-2') {
              token.clear();
              this.$message.success('退出成功！');
              this.$router.push({path: '/'});
            } else {
              let index = key.charAt(key.length - 1);
              this.$router.push({path: '/accountCenter',query:{ index:index}});
            }
          }
        },
      }
    }
</script>

<style lang="scss" scoped="scoped">
    .nav_bar {
        position: fixed;
        z-index: 999;
        top: 0;
        width: 100%;
        height: 80px;
        background-color: #fff;
    }
    
    .nav {
        display: flex;
        align-items: center;
        height: 80px;
        border-bottom: 1px solid rgba(212, 212, 212, 1);
    }
    /* logo */
    
    .logo_box {
      margin-left: 25px;
    }

    /* name */
    
    .name {
        display: inline-block;
        height: 78px;
        border-bottom: 2px solid rgba(80, 125, 241, 1);
        font-size: 18px;
        color: #3C3C3C;
        text-align: center;
        line-height: 78px;
    }

    .name:hover {
      cursor: pointer;
    }

    /* right_option */
    
    .right_option {
        display: flex;
        justify-content: right;
        align-items: center;
        margin-right: 70px;
        font-size: 13px;
        color: #333;
    }
    
    .right_option div {
        height: 79px;
        padding: 0 20px;
        line-height: 79px;
    }
    
    a {
        color: #333;
        text-decoration: none;
    }
    
    a:hover {
        cursor: pointer;
        color: #537EEE;
    }
    
    .right_option i {
        font-size: 18px;
    }
    // el-menu
    .el-menu {
      display: inline-block;
      padding-right: 20px;
      border-bottom: none;
    }

    .el-menu--horizontal>.el-menu-item {
      height: 80px;
      line-height: 80px;
    }

    /deep/ .el-menu--horizontal>.el-submenu .el-submenu__title {
      height: 80px;
      line-height: 80px;
    }

    /deep/ .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow{
    	display: none; 
    }

    /deep/ .el-submenu>.el-submenu__title .el-submenu__icon-arrow{
    	display: none;
    }
    .el-menu--horizontal>.el-menu-item a{
      display: inline-block;
      height: 80px;
      color: #333;
    }
    .el-menu--horizontal>.el-menu-item a:hover {
      color: #537EEE;
    }
    .el-menu-item i,.el-submenu__title i {
      color: #333;
    }
    .el-menu-item i:hover,.el-submenu__title i:hover {
      color: #537EEE;
    }
    //选项
    .hover_item:hover {
      color: #537EEE!important;
      background-color: #F8F9FF;
    }
    //消息中心
    .message_center {
      position: relative;
      .message_box {
        position: absolute;
        width: 280px;
        // height: 300px;
        background-color: #fff;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        .box_title {
          display: flex;
          justify-content: space-between;
          height: 40px;
          padding: 0 10px;
          line-height: 40px;
          span {
            font-size: 14px;
            color: #4F4F4F;
          }
          i {
            font-style: normal;
            font-size: 12px;
            color: #5984EC;
          }
          i:hover {
            // cursor: pointer;
            text-decoration: underline;
          }
        }
        .message_item {
          padding: 15px 20px;
          border-top: 1px solid #E5E5E5;
          text-align: left;
          .message_title {
            height: 18px;
            font-size: 12px;
            color: #6C6C6C;
            line-height: 18px;
            overflow:hidden; 
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .message_time {
            height: 15px;
            font-size: 10px;
            color: #A7A7A7;
            line-height: 15px;
          }
        }
        .message_item:hover {
          background-color: #E9EFFF;
        }
      }
    }
    //头像
    .head_portrait {
      width: 42px;
      height: 42px;
      margin-right: 8px;
      border-radius: 50%;
    }
    .exit_btn {
      border-top: 1px solid #E5E5E5;
    }
</style>

<style lang="scss">
  .el-menu--collapse .el-menu .el-submenu, .el-menu--popup{
    min-width: 140px!important;
  }
  .el-menu--horizontal>.el-menu-item.is-active {
    border-color: #507DF1;
  }
</style>